module.exports = __webpack_public_path__ + "static/media/Avatar_11.8505b165.svg";